import React from 'react';
// import { Link } from 'react-router-dom';
import HeroCarousel from '../components/HeroCarousel';
// import PropertyCard from '../components/PropertyCard';
import Values from '../components/Values';
import Statistics from '../components/Statistics';
import InvestmentGuideSection from '../components/InvestmentGuideSection';
import PartnersSection from '../components/PartnersSection';
import ServicesSection from '../components/ServicesSection';
import IntroSection from '../components/IntroSection';
// import TestimonialsSection from '../components/TestimonialsSection';

import '../styles/Home.css';

const Home = () => {
  return (
    <div className="home">
      <div className="main-content">
        <HeroCarousel />
        <IntroSection />
        <ServicesSection />
        <Values />
        {/* <TestimonialsSection /> */}
        <Statistics />
        <InvestmentGuideSection />
        <PartnersSection />
      </div>
    </div>
  );
};

export default Home; 